import React, { Component, lazy, Suspense } from 'react'
import { Route, Routes } from 'react-router-dom'
import { connect } from 'react-redux';

import Shimmer from './components/shimmer/shimmer.component';
import Faq from './pages/faqpage/faqpage.components';
import FaqDetailsBooking from './pages/faqdetailspage/faqdetailspage-booking.components';
import FaqDetailsRefund from './pages/faqdetailspage/faqdetailspage-refund.components';
import FaqdetailspagePnrStatus from './pages/faqdetailspage/faqdetailspage-pnr-status.components';
import FaqDetailsPayment from './pages/faqdetailspage/faqdetailspage-payment.components';
import FaqDetailsAccount from './pages/faqdetailspage/faqdetailspage-account.components';
import FaqDetailsMeal from './pages/faqdetailspage/faqdetailspage-meal.components';
import FaqDetailsTechnical from './pages/faqdetailspage/faqdetailspage-technical.components';
import FaqDetailsTraininfo from './pages/faqdetailspage/faqdetailspage-traininfo.components';
import FaqDetailsIRCTC from './pages/faqdetailspage/faqdetailspage-irctc.components';
import FaqDetailsMiscell from './pages/faqdetailspage/faqdetailspage-miscellous.components';
import './App.css';

const HelpPage = lazy(() => import('./pages/helppage/helppage.component'))
const Unknownuser = lazy(() => import('./pages/unknowuser/unknowuser.component'))


class App extends Component {
  constructor(props) {
    super(props)
    this.props.reset()
  }
  render() {
    return (
      <Suspense fallback={<Shimmer />}>
        <Routes>
          <Route path="/ttbhelp" element={<HelpPage />} />
          <Route path="/ttbhelp/Faq" element={<Faq />} />
          <Route path="/ttbhelp/Faqdetails/booking-and-ticking" element={<FaqDetailsBooking />} />
          <Route path="/ttbhelp/Faqdetails/refunds-and-cancellations" element={<FaqDetailsRefund />} />
          <Route path="/ttbhelp/Faqdetails/pnr-train-status" element={<FaqdetailspagePnrStatus/>} />
          <Route path="/ttbhelp/Faqdetails/payment" element={<FaqDetailsPayment/>} />
          <Route path="/ttbhelp/Faqdetails/account" element={<FaqDetailsAccount/>} />
          <Route path="/ttbhelp/Faqdetails/meal" element={<FaqDetailsMeal/>} />
          <Route path="/ttbhelp/Faqdetails/technical" element={<FaqDetailsTechnical/>} />
          <Route path="/ttbhelp/Faqdetails/traininfo" element={<FaqDetailsTraininfo/>} />
          <Route path="/ttbhelp/Faqdetails/irctc" element={<FaqDetailsIRCTC/>} />
          <Route path="/ttbhelp/Faqdetails/miscellaneous" element={<FaqDetailsMiscell/>} />
          <Route path="/ttbhelp/unknown" element={<Unknownuser />} />
        </Routes>
      </Suspense>
    );
  };

}
const mapDispatchToProps = dispatch => ({
  reset: () => dispatch({ type: 'RESET' }),
})

export default connect(null, mapDispatchToProps)(App);
